const DECORATION_TYPES = Object.freeze({
  GENERATE_TABLE_CACHE_ID: 'GENERATE_TABLE_CACHE_ID'
});

export default DECORATION_TYPES;
